import { RegistrationService } from 'services/main/endpoints/RegistrationService';
import { createToast, createErrorToast } from './createToast';
import { saveToOutbox, processOutbox } from './outbox';
import { readFileIntoMemory } from './readFileIntoMemory';
import * as Sentry from '@sentry/react';

const MAX_FILE_SIZE = 10 * 1024 * 1024;

export const uploadDocument = async ({ file, filePath, token }) => {
  const response = await RegistrationService.uploadSignature({ filePath, file, token });

  if (response.status === 401) {
    throw new Error('Token inválido');
  }

  return response;
};

const handleDocUpload = async (imageData, token, setToastList, empresaId, cookie, contextSetToastList) => {
  if (!imageData || typeof imageData === 'string') {
    return imageData;
  }

  let file = imageData.file;

  if (file.size > MAX_FILE_SIZE) {
    createErrorToast(setToastList, `O arquivo excede o tamanho máximo permitido de 10MB.`);
    throw new Error('O arquivo excede o tamanho máximo permitido de 10MB.');
  }

  // Arquivo ilegível não tem outbox que resolva — só selecionar de novo.
  try {
    file = await readFileIntoMemory(file);
  } catch (error) {
    createErrorToast(contextSetToastList, 'Não foi possível ler o arquivo. Selecione-o novamente.');
    Sentry.logger.info('Upload - arquivo ilegível', { empresa_id: cookie?.companies?.id, error: String(error) });
    return null;
  }

  const loadingToast = createToast({
    type: 'loading',
    message: 'Estamos criando o documento...',
  });

  setToastList(prev => [...prev, loadingToast]);

  try {
    const response = await uploadDocument({
      file,
      filePath: imageData.cloudPath,
      token,
    });
    return response;
  } catch (error) {
    try {
      await saveToOutbox({
        file,
        filePath: imageData.cloudPath,
        empresaId,
        type: 'document',
      });
      processOutbox(cookie, contextSetToastList);
      createErrorToast(contextSetToastList, 'Erro ao enviar o documento. Vamos tentar novamente em segundo plano.');
    } catch (outboxError) {
      Sentry.captureException(outboxError, {
        tags: { area: 'outbox', action: 'save_document' },
        extra: { empresa_id: cookie?.companies?.id },
      });
      createErrorToast(
        contextSetToastList,
        'Não foi possível enviar nem salvar o documento para reenvio. Tente novamente.',
      );
    }
    return null;
  } finally {
    setToastList(prev => prev.filter(t => t.id !== loadingToast.id));
  }
};

export { handleDocUpload };
